import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {faPlay} from "@fortawesome/free-solid-svg-icons";
import {CodeOutputComponent, CodeResult} from "../code-output/code-output.component";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import { NgIf, CommonModule } from "@angular/common";
import {EditorComponent} from "ngx-monaco-editor-v2";
import {FormsModule} from "@angular/forms";
import {ExamService} from "../../../exam/data-access/exam.service";
import {MatSnackBar} from "@angular/material/snack-bar";

export interface SampleCase {
  name: string
  id: number
  input: string[]
  timeoutSecs: number
  outputExpected: string[]
  outputReceived: string[]
  correctness: boolean
}
@Component({
    selector: 'code-editor',
    templateUrl: 'code-editor.component.html',
    imports: [
        FaIconComponent,
        NgIf,
        EditorComponent,
        CodeOutputComponent,
        FormsModule,
        CommonModule
    ],
    styleUrls: ['code-editor.component.css']
})
export class CodeEditorComponent implements OnChanges{
  constructor(private examService: ExamService, private _snackBar: MatSnackBar) {}
  theme = 'vs-light'
  lang = 'java'
  editorOptions = {theme: this.theme, language: this.lang};
  @Input('answerSkeleton') answerSkeleton: string[] = [];
  @Input('recordedAnswer') recordedAnswer?: string;
  @Input('sampleCases') sampleCases: SampleCase[] = []
  @Input('samplesRemaining') samplesRemaining: number = -1
  @Input('exam_uuid') exam_uuid = ''
  @Input('part_position') part_position = -1
  @Input('question_position') question_position = -1
  @Input('review') review = false
  @Input('code') code? = ''
  @Input('argumentNames') argumentNames?: string[] = [];
  @Input('initialLanguage') initialLanguage = 'java'
  @Input('initialTheme') initialTheme = 'vs-light'
  @Output() codeChange = new EventEmitter<string>()
  @Output() onChangeEmitter = new EventEmitter<Function>()
  @Output() samplesRemainingChange = new EventEmitter<number>()
  codeResult?: CodeResult = undefined
  // TODO need to fix and add loaders
  isLoading = false

  onInit(editor: any) 
  {
    this.sampleCases[0].input[0].split(',')
  }

  ngOnChanges(changes: SimpleChanges) {
    if(this.recordedAnswer == undefined) {
      this.code = this.answerSkeleton.join('')
    }
    if(this.sampleCases.length > 0 && this.sampleCases[0].outputReceived.length > 0) {
      this.codeResult = {
        compileError: [],
        cases: [],
        samplesRemaining: this.samplesRemaining
      }
      for(let i = 0; i < this.sampleCases.length; i++) {
        this.codeResult.cases.push({
          ...this.sampleCases[i],
          output: this.sampleCases[i].outputReceived,
          expectedOutput: this.sampleCases[i].outputExpected,
          runtimeError: [],
          correctness: this.sampleCases[i].correctness
        })
      }
    } else if (changes['sampleCases']) {
      this.codeResult = undefined
    }
  }

  changeTheme(value: Event) {
    this.theme = (<HTMLSelectElement>value.target).value
    this.editorOptions = Object.assign({}, this.editorOptions, {theme: this.theme, language: this.lang})
  }

  runClick() {
    if(this.samplesRemaining > 0) {
      this.isLoading = true
      this.examService.runCodeSample(this.exam_uuid, this.part_position, this.question_position, this.code).subscribe((response) => {
        this.isLoading = false
        if(response.success) {
          this.codeResult = {
            compileError: response.result.compileError,
            cases: response.result.cases,
            samplesRemaining: response.result.samplesRemaining
          }
          for(let i = 0; i < this.codeResult.cases.length; i++) {
            this.codeResult.cases[i] = {
              ...this.codeResult.cases[i],
              input: this.sampleCases[i].input,
              expectedOutput: this.sampleCases[i].outputExpected
            }
          }
          this.samplesRemaining = response.result.samplesRemaining
          this.samplesRemainingChange.emit(this.samplesRemaining)
          this.onChange(this.code);
        } else {
          this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
        }
      })
    } else {
      this._snackBar.open('No more attempts left!', 'Dismiss', {panelClass: ['error-snackbar']})
    }
  }

  onChange(code: string | undefined) {
    if(code != undefined) {
      this.codeChange.emit(code)
      this.onChangeEmitter.emit(this.onChangeEmitter)
    }
  }

  protected readonly console = console;
  protected readonly faPlay = faPlay;
}
